export const googleTranslateLanguages = [
  { value: 'pt', label: 'Português', countryCode: 'pt' },
  { value: 'en', label: 'English', countryCode: 'us' },
  { value: 'fr', label: 'Français', countryCode: 'fr' },
  { value: 'hi', label: 'हिन्दी', countryCode: 'in' },
  { value: 'bn', label: 'বাংলা', countryCode: 'bn' },
  { value: 'ar', label: 'العربية', countryCode: 'sa' },
  { value: 'zh-CN', label: '中文', countryCode: 'cn' },
  { value: 'ru', label: 'Русский', countryCode: 'ru' },
  { value: 'uk', label: 'Українська', countryCode: 'ua' },
  { value: 'sw', label: 'Kiswahili', countryCode: 'ke' },
  { value: 'ro', label: 'Română', countryCode: 'ro' },
  { value: 'tr', label: 'Türkçe', countryCode: 'tr' },
  { value: 'it', label: 'Italiano', countryCode: 'it' },
  { value: 'es', label: 'Español', countryCode: 'es' },
];
